import {
  type BuildDetailsFieldsParams,
  field,
  leftColumn,
  readOnlyField,
  rightColumn,
  typedField,
  withLayout,
} from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildKeyDatesFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const keyDates = opportunity?.key_dates;
  const runDates = opportunity?.run_dates;

  return [
    typedField('Travel From', keyDates?.expiry_date_travel_from__c, 'date', undefined, leftColumn),
    typedField('Travel To', keyDates?.travel_to__c, 'date', undefined, leftColumn),
    typedField('Book By', keyDates?.book_by__c, 'date', undefined, leftColumn),
    withLayout(
      readOnlyField('Online Duration (LE)', runDates?.online_duration_le__c, 'Calculated from run dates.'),
      rightColumn,
    ),
    typedField('Planned Run Date (LE)', runDates?.planned_run_date_le__c, 'date', undefined, rightColumn),
    typedField('Planned End Date (LE)', undefined, 'date', undefined, rightColumn),
    typedField(
      'Original Schedule Start',
      runDates?.first_schedulable_date__c,
      'date',
      'Earliest Online Start Date from campaign schedules. Critical for DMC payment calculations.',
      rightColumn,
    ),
    withLayout(field('Offline Run Period', runDates?.offline_run_period__c), rightColumn),
    typedField('Offline End Date', undefined, 'date', undefined, rightColumn),
  ];
}
